<script lang="ts">
import type { Snippet } from "svelte";

/** A section's title, ending in the red stop, over an optional body. */
let {
	id,
	title,
	align = "start",
	children,
}: { id: string; title: string; align?: "start" | "center"; children?: Snippet } = $props();
</script>

<div class="heading" data-align={align}>
	<h2 {id}>{title}<span class="stop">.</span></h2>
	{#if children}
		<div class="body">{@render children()}</div>
	{/if}
</div>

<style>
	.heading {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.heading[data-align="center"] {
		align-items: center;
		text-align: center;
	}

	/* A parent can set `--heading-color` to change the title's colour. */
	h2 {
		color: var(--heading-color, var(--ink));
		font-family: "Inter Variable", var(--font-sans);
		font-variation-settings: "opsz" 32;
		font-size: clamp(1.75rem, 2.4vw, 2.25rem);
		line-height: 1.1;
		font-weight: 600;
		letter-spacing: -0.025em;
		text-wrap: balance;
	}

	.stop {
		color: var(--primary);
	}

	.body {
		max-width: 48rem;
		color: var(--muted-foreground);
		font-size: 19px;
		line-height: 30px;
		text-wrap: pretty;
	}

	/* A parent can set `--paragraph-gap` to change the space between the body's paragraphs. */
	.body :global(p + p) {
		margin-top: var(--paragraph-gap, 1lh);
	}

	@media (max-width: 767px) {
		.body {
			font-size: 17px;
			line-height: 27px;
		}
	}
</style>
